<template>
  <div class="report-table-root">
    <!-- REPORT CREATE/UPDATE DIALOG -->
    <v-dialog v-if="reportEdit" v-model="reportDialog" max-width="790">
      <v-card>
        <v-card-text>
          <img
            @click="reportDialog = false"
            class="close-icon"
            src="../../assets/icons/close.png"
            alt="Close"
          />
          <report-create
            :dialog="reportDialog"
            :isUpdate="isReportUpdate"
            @refreshData="refreshData"
            @closeDialog="closeDialog"
            :appointmentUsersId="selectedAppointment"
          ></report-create>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <REPORT LIST DIALOG> -->
    <v-dialog v-if="reportPreview" v-model="reportDialog" max-width="790">
      <reports-list
        @closeModal="reportDialog = false"
        :appointmentId="selectedAppointment"
      ></reports-list>
    </v-dialog>
    <v-container>
      <v-data-table
        :headers="headers"
        :items="tableData"
        hide-actions
        id="scroll-container"
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <tr :class="{
            'one-day-overdue': props.item.oneDayPassed,
            'five-days-overdue': props.item.fiveDaysPassed,
            'seven-days-overdue': props.item.sevenDaysPassed,
          }">
            <td class="text-xs-left">
              {{ props.item.Date.replaceAll("-", ".") }}
            </td>
            <td class="text-xs-left">{{ props.item.Time.split(" - ")[0] }}</td>
            <td class="text-xs-left">{{ props.item.Time.split(" - ")[1] }}</td>
            <td class="text-xs-left">{{ props.item.Studio }}</td>
            <td class="text-xs-center">
              <img
                v-if="!props.item.IsReported"
                @click="
                  openReportDialog(
                    reportPreview
                      ? props.item.AppointmentId
                      : props.item.AppointmentUsersId,
                    false
                  )
                "
                class="action-icon-sm"
                :class="{ 'td-disabled': reportDisabled }"
                src="../../assets/icons/report.png"
                alt="Report"
              />

              <img
                v-else
                @click="
                  openReportDialog(
                    reportPreview
                      ? props.item.AppointmentId
                      : props.item.AppointmentUsersId,
                    true
                  )
                "
                class="action-icon-sm"
                :class="{ 'td-disabled': reportDisabled }"
                src="../../assets/icons/report-edit.png"
                alt="Report edit"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
    <!-- <PAGINATION> -->
    <div v-if="numberOfPages > 1" class="text-xs-center pagination">
      <v-pagination
        :total-visible="6"
        @input="refreshData"
        v-model="selectedPage"
        :length="numberOfPages"
      ></v-pagination>
    </div>
  </div>
</template>
<script>
import ReportCreate from "../Reports/Create";
import ReportsList from "../Reports/List";

export default {
  props: [
    "tableData",
    "numberOfPages",
    "reportEdit",
    "reportPreview",
    "reportDisabled",
    "selectedPage",
  ],
  components: { ReportCreate, ReportsList },
  data() {
    return {
      //Data table headers
      headers: [
        {
          text: "Datum termina",
          value: "datum",
          align: "left",
        },
        {
          text: "Vrijeme od",
          value: "vrijemeOd",
          align: "left",
        },
        {
          text: "Vrijeme do",
          value: "vrijemeDo",
          align: "left",
        },
        {
          text: "Studio",
          value: "studio",
          align: "left",
        },
        {
          text: "Akcije",
          value: "akcije",
          align: "center",
        },
      ],
      selectedAppointment: null,
      isReportUpdate: false,
      reportDialog: false,
    };
  },
  methods: {
    openReportDialog(appointmentUsersId, isUpdate) {
      this.selectedAppointment = appointmentUsersId;
      this.reportDialog = true;
      this.isReportUpdate = isUpdate;
    },
    closeDialog() {
      this.reportDialog = false;
    },
    refreshData() {
      this.closeDialog();
      this.$emit("refreshTableData", this.selectedPage);
      //this.getAppointmentsByUser();
    },
  },
  watch: {
    reportDialog() {
      if (this.reportDialog == false) {
        this.isReportUpdate = false;
      }
    },
    selectedPage() {
      let scrollContainer = document.getElementById("scroll-container");
      let scrollContainerX = document.getElementsByClassName(
        "v-table__overflow"
      )[0];
      scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
      scrollContainerX.scrollTo({ left: 0, behavior: "smooth" });
    },
  },
  created() {},
};
</script>
<style scoped>
.report-table-root {
  padding-bottom: 55px;
}
.elevation-1 {
  overflow-y: auto;
}
.report-table-root,
.container,
.elevation-1,
.elevation-1,
table.v-table,
tbody {
  height: 100%;
}
.td-disabled {
  cursor: not-allowed;
  opacity: 0.3;
}
.pagination {
  background-color: #fff;
  margin: 0;
  padding: 15px 0;
}
</style>
